export default __webpack_public_path__ + "static/media/logo.9226a46a.png";